<template>
  <div>
    <button
      v-if="
        status > 1 &&
        status !== 4 &&
        status !== 6 &&
        status !== 3 &&
        status !== 7 &&
        status !== 8 &&
        !advance &&
        totalAmount &&
        type == '1'
      "
      outline
      class="tra-ass-btn"
      type="button"
      @click.stop="
        check();
        getBankName();
      "
    >
      Generate
    </button>
    <v-btn
      class="ma-2 request-advance-trigger-btn"
      v-if="!advance && !type && totalAmount"
      color="orange"
      dark
      prepend-icon
      :disabled="
        status <= 1 ||
        status === 4 ||
        status === 6 ||
        status === 3 ||
        status === 7 ||
        status === 8 ||
        viewOnly == 'view' ||
        customerStatus == 'view'
      "
      @click.stop="
        check();
        getBankName();
      "
    >
      + Request Advance
    </v-btn>
    <v-dialog
      v-model="dialog"
      max-width="52rem"
      persistent
      content-class="request-advance-dialog"
      class="layout__spacing request-advance-dialog-wrap"
    >
      <v-form
        ref="form"
        v-model="valid"
        :lazy-validation="lazy"
        height="100%"
        onSubmit="return false;"
        class="layout__spacing"
      >
        <v-card class="request-advance-card">
          <header class="request-advance-header">
            <div class="request-advance-header__brand">
              <div class="request-advance-header__badge" aria-hidden="true">
                <v-icon>payment</v-icon>
              </div>
              <h2 class="request-advance-title-text">Request Advance</h2>
            </div>
            <v-btn
              icon
              class="request-advance-close"
              :disabled="processing"
              @click.prevent="close"
              title="Close"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </header>
          <v-progress-linear
            indeterminate
            color="trukkin-theme darken-2"
            v-show="processing"
          ></v-progress-linear>
          <div class="request-advance-body">
            <div class="request-advance-summary">
              <span class="dashboard-style">Driver’s Payment credit period</span>
              <strong>
                {{
                  driverCreditDuration !== 0 &&
                  driverCreditDuration !== undefined
                    ? driverCreditDuration + " days"
                    : "N.A"
                }}
              </strong>
            </div>

            <div class="request-advance-grid">
              <div class="request-advance-field">
                <label class="request-advance-label"
                  >Advance amount to be paid to driver*</label
                >
                <v-text-field
                  v-model="advancePayment"
                  class="pt-0 currencyTitle request-advance-input"
                  type="number"
                  box
                  placeholder="Enter amount"
                  :rules="[rules.required]"
                ></v-text-field>
              </div>
              <div class="request-advance-field">
                <label class="request-advance-label"
                  >Total amount to be paid to driver*</label
                >
                <v-text-field
                  readonly
                  v-model="totalAmount"
                  class="pt-0 currencyTitle request-advance-input"
                  box
                  hide-details
                  placeholder="Total amount to be paid to driver."
                ></v-text-field>
              </div>
              <div class="request-advance-field request-advance-field--full">
                <label class="request-advance-label">Comments</label>
                <v-textarea
                  box
                  class="request-advance-input"
                  name="input-7-4"
                  placeholder="Comments"
                  rows="2"
                  auto-grow
                  hide-details
                  v-model="comments"
                ></v-textarea>
              </div>
            </div>

            <div class="request-advance-section-heading">
              <span class="heading__span">Driver Payment Details</span>
            </div>

            <div class="request-advance-payment-grid">
              <div class="request-advance-field request-advance-field--full">
                <v-radio-group
                  class="mt-0 pt-0 request-advance-radio"
                  v-model="modeOfPayment"
                  row
                  :mandatory="true"
                  @change="this.$refs.form.resetValidation()"
                  :rules="[rules.required]"
                  hide-details
                >
                  <v-radio
                    label="Cash"
                    value="Cash"
                    color="orange darken-1"
                  ></v-radio>
                  <v-radio
                    label="Bank Transfer"
                    value="Bank Transfer"
                    color="orange darken-1"
                  ></v-radio>
                </v-radio-group>
              </div>

              <div class="request-advance-field">
                <label class="request-advance-label">Account Holder Name</label>
                <v-text-field
                  v-model="accountHolderName"
                  class="pt-0 currencyTitle request-advance-input"
                  box
                  placeholder="Enter account holder name"
                  :rules="
                    modeOfPayment === 'Bank Transfer'
                      ? [rules.noWhiteSpace, rules.required]
                      : []
                  "
                ></v-text-field>
              </div>

              <div class="request-advance-field">
                <label class="request-advance-label">IBAN Number</label>
                <v-text-field
                  v-model="ifscCode"
                  class="pt-0 currencyTitle request-advance-input"
                  box
                  placeholder="IBAN Number"
                  maxlength="25"
                  :rules="
                    modeOfPayment === 'Bank Transfer'
                      ? [rules.noWhiteSpace, rules.required]
                      : []
                  "
                ></v-text-field>
              </div>

              <div class="request-advance-field">
                <label class="request-advance-label">Account Number</label>
                <v-text-field
                  v-model="accountNumber"
                  class="pt-0 currencyTitle request-advance-input"
                  box
                  placeholder="Account number"
                  :rules="
                    modeOfPayment === 'Bank Transfer'
                      ? [rules.noWhiteSpace, rules.required]
                      : []
                  "
                ></v-text-field>
              </div>

              <div class="request-advance-field">
                <label class="request-advance-label">Swift Number</label>
                <v-text-field
                  v-model="swiftNumber"
                  class="pt-0 currencyTitle request-advance-input"
                  box
                  placeholder="Enter Swift Number"
                  :rules="
                    modeOfPayment === 'Bank Transfer'
                      ? [rules.noWhiteSpace, rules.required]
                      : []
                  "
                ></v-text-field>
              </div>
            </div>

            <v-card-actions class="request-advance-actions">
              <v-spacer></v-spacer>
              <v-btn
                class="request-advance-cancel-btn"
                color="red darken-1"
                :disabled="processing"
                flat
                @click="close()"
                >Close</v-btn
              >
              <v-btn
                class="request-advance-submit-btn"
                color="orange darken-1"
                dark
                :disabled="processing"
                @click="checkAdvance()"
                >Submit</v-btn
              >
            </v-card-actions>
          </div>
        </v-card>
      </v-form>
      <v-dialog
        v-model="confirmationDialog"
        class="request-advance-confirm-dialog"
        max-width="23%"
        persistent
      >
        <v-card class="request-advance-confirm-card">
          <!-- <v-layout>
            <v-flex style="text-align: end;">
              <v-btn icon>
                <v-icon
                  small
                  @click.prevent="confirmationDialog = false"
                  :disabled="loading"
                  >close</v-icon
                >
              </v-btn>
            </v-flex>
          </v-layout> -->
          <v-spacer class="spacerclass">
            <v-card-text style="padding-top: 0px !important">
              <v-layout class="pt-4" style="text-align: center">
                <v-flex pr-2 pb-3>
                  <v-icon x-large color="orange">info</v-icon></v-flex
                >
              </v-layout>
              <v-layout>
                <v-flex pb-3 style="text-align: center">
                  Advance amount exceeds the {{ operatorDisplayLabel.toLowerCase() }} price.</v-flex
                >
              </v-layout>
              <v-layout>
                <v-flex style="text-align: center">
                  <v-btn
                    class="request-advance-submit-btn request-advance-ok-btn"
                    color="orange darken-1"
                    dark
                    @click.prevent="generateAdvance()"
                    :loading="processing"
                    >OK</v-btn
                  ></v-flex
                >
              </v-layout>
            </v-card-text>
          </v-spacer>
        </v-card>

        <v-snackbar
          :timeout="3000"
          bottom
          color="red darken-2"
          v-model="x.error"
          class="white--text"
          v-if="x.error"
          >{{ x.error }}</v-snackbar
        >
      </v-dialog>
      <v-snackbar
        :timeout="3000"
        bottom
        color="red darken-2"
        v-model="x.error"
        class="white--text"
        v-if="x.error"
        >{{ x.error }}</v-snackbar
      >
    </v-dialog>
  </div>
</template>
<script>
import { getModeIcon } from "@/utils/shipmentLabels";
import moment from "moment";
import { StorageKeys, Banks } from "../../constants/constants";
import { generateAdvance } from "@/constants/api-urls.js";
import ErrorBox from "@/components/Common/ErrorBox";
export default {
  components: {
    ErrorBox,
  },

  data() {
    return {
      operationName: "",
      banks: [],
      confirmationDialog: false,
      options: {
        color: "#ffc04c",
        width: 500,
        zIndex: 200,
      },
      bankName: "",
      activity: [],
      modeOfPayment: "Cash",
      customerStatus: "",
      accountHolderName: "",
      comments: "",
      accountNumber: "",
      swiftNumber: "",
      ifscCode: "",
      valid: true,
      lazy: false,
      reason: "",
      processing: false,
      dialog: false,
      disStatus: false,
      loading: false,
      advancePayment: null,
      rules: {
        required: (value) => !!value || "This field is required.",
        noWhiteSpace: (v) =>
          (v != null && v.trim().length > 0) || "Enter valid value.",
        amount: (v) =>
          /^\d*(\.\d+)?$/.test(v) || "Enter a valid amount. E.g 10 or 10.20",
        number: (v) => /^[0-9]*$/.test(v) || "Please enter valid amount",
      },
      x: {
        error: "",
      },
    };
  },
  watch: {
    modeOfPayment() {
      this.$refs.form.resetValidation();
    },
  },
  props: {
    jobType: [String, Number],
    assId: Number,
    totalAmount: Number,
    totalAdvanceAmount: Number,
    maximumAdvanceLeftAmount: Number,
    driverCreditDuration: Number,
    advance: Number,
    currency: String,
    invoiceCity: String,
    invoiceCompany: String,
    isCancel: Boolean,
    viewOnly: Boolean,
    status: Number,
    advancedialog: Boolean,
    additionalCharges: Number,
    totaladvancePaid: Number,
    assignedToTransporter: Boolean,
    ownerType: String,
    type: String,
  },
  computed: {
    operatorDisplayLabel() {
      const jobType = String(this.jobType || "1");
      if (jobType === "2") return "Carrier";
      if (jobType === "3") return "Vessel";
      return "Driver";
    },
    modeIcon() {
      return getModeIcon(this.jobType);
    },
  },
  created() {
    this.customerStatus = localStorage.getItem("cust-status");
    this.totalPayment = this.$props.totalAmount;

    // this.getActivityLog();
  },
  methods: {
    getBankName() {
      if (this.$props.invoiceCity == "1" && this.$props.invoiceCompany == "1") {
        this.bankName = "Alinma Bank - Dammam";
      } else if (
        this.$props.invoiceCity == "2" &&
        this.$props.invoiceCompany == "1"
      ) {
        this.bankName = "Alinma Bank - Jeddah";
      } else if (
        this.$props.invoiceCity == "3" &&
        this.$props.invoiceCompany == "1"
      ) {
        this.bankName = "Alinma Bank - Riyadh";
      } else if (
        this.$props.invoiceCompany == "2" &&
        (this.$props.invoiceCity == "1" || this.$props.invoiceCity == "2")
      ) {
        this.banks = [
          "HB-81591",
          "ENBD-80701",
          "ADCB-20001",
          "MB-60847",
          "MB-6094",
        ];
      } else {
        return;
      }
    },
    async check() {
      if (this.$route.name == "Accounts")
        this.operationName = "add-advance-for-accounts";
      if (this.$route.name != "Accounts")
        this.operationName = "generate-advance-jobs";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.dialog = true;
        this.modeOfPayment = "Cash";
      } else {
        return;
      }
    },
    close() {
      this.dialog = false;
      this.advancePayment = null;
      this.modeOfPayment = "Cash";

      this.accountHolderName = "";
      this.accountNumber = "";
      this.swiftNumber = "";
      this.comments = "";
      this.ifscCode = "";
      this.bankName = "";
      this.$refs.form.resetValidation();
      this.totalPayment = this.$props.totalAmount;
    },
    getTime(date) {
      return moment(date).format("YYYY-MM-DD hh:mm A");
    },
    checkAdvance() {
      this.processing = true;
      let isAdvancePaidMoreThanRequested =
        this.$props.totalAdvanceAmount < this.totaladvancePaid ? true : false;
      if (this.$refs.form.validate()) {
        if (!this.advancePayment) {
          this.x.error = "Please enter advance amount";
          this.processing = false;
          return;
        }
        if (this.advancePayment <= 0) {
          this.x.error = "Advance amount should be greater than or equal to 1";
          this.processing = false;
          return;
        }
        // if (parseInt(this.advancePayment) > this.maximumAdvanceLeftAmount) {
        //   this.confirmationDialog = true;
        //   return;
        // }
        if (
          parseInt(this.advancePayment) >
          this.totalAmount + this.additionalCharges - this.totaladvancePaid
        ) {
          this.processing = false;
          console.log("--------------1--");
          // if (
          //   this.$props.assignedToTransporter ||
          //   this.$props.ownerType == "Transporter"
          // ) {
          //   this.x.error =
          //     "Advance amount can't be greater than total amount to be paid to driver";
          //   return;
          // } else {
          this.processing = false;
          this.confirmationDialog = true;
          return;
          // }
        }
        if (isAdvancePaidMoreThanRequested) {
          if (
            this.totaladvancePaid + Number(this.advancePayment) >
            this.totalAmount + this.additionalCharges
          ) {
            // if (
            //   this.$props.assignedToTransporter ||
            //   this.$props.ownerType == "Transporter"
            // ) {
            //   this.x.error =
            //     "Advance amount can't be greater than total amount to be paid to driver";
            //   return;
            // } else {
            this.processing = false;
            this.confirmationDialog = true;
            return;
          } else {
            this.generateAdvance();
          }
        } else {
          if (
            this.$props.totalAdvanceAmount + Number(this.advancePayment) >
            this.totalAmount + this.additionalCharges
          ) {
            // if (
            //   this.$props.assignedToTransporter ||
            //   this.$props.ownerType == "Transporter"
            // ) {
            //   this.x.error =
            //     "Advance amount can't be greater than total amount to be paid to driver";
            //   return;
            // } else {
            this.processing = false;
            this.confirmationDialog = true;
            return;
            // }
          } else {
            this.generateAdvance();
          }
        }
      } else {
        this.processing = false;
        return;
      }
    },
    async generateAdvance() {
      this.processing = true;
      if (this.$route.name == "Accounts")
        this.operationName = "add-advance-for-accounts";
      if (this.$route.name != "Accounts")
        this.operationName = "generate-advance-jobs";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.processing = false;

        if (this.$refs.form.validate()) {
          if (!this.advancePayment) {
            this.x.error = "Please enter advance amount";
            this.processing = false;
            return;
          }
          if (this.advancePayment <= 0) {
            this.x.error =
              "Advance amount should be greater than or equal to 1";
            this.processing = false;
            return;
          }

          this.processing = true;
          let url = generateAdvance;
          delete this.axios.defaults.headers.common["token"];
          let token = localStorage.getItem(StorageKeys.SessionKey);
          let config = {
            headers: {
              authorization: `bearer ${token}`,
            },
          };
          let body = {
            assignmentId: this.$props.assId.toString(),
            advancePayment: this.advancePayment.toString(),
            totalPayment: this.$props.totalAmount.toString(),
            creditorModeOfPayment: this.modeOfPayment,
          };
          // if (this.bankName) {
          //   body.bank = this.bankName;
          // }
          if (this.ifscCode) {
            body.IBANNumber = this.ifscCode;
          }
          if (this.accountHolderName) {
            body.accountHolderName = this.accountHolderName;
          }
          if (this.accountNumber) {
            body.accountNumber = this.accountNumber;
          }
          if (this.swiftNumber) {
            body.swiftNumber = this.swiftNumber;
          }
          if (this.comments) {
            body.comment = this.comments;
          }

          this.axios.post(this.constants.apiUrl + url, body, config).then(
            (response) => {
              this.x.success = true;
              this.dialog = false;
              this.processing = false;
              this.$refs.form.resetValidation();
              this.$emit("assignment-list-refresh");
              this.modeOfPayment = "";
              this.accountHolderName = "";
              this.accountNumber = "";
              this.swiftNumber = "";
              this.comments = "";
              this.ifscCode = "";
              this.bankName = "";
              this.x.message = response.data.message;
              this.$emit("updateAssignment");
              this.advancePayment = null;
              this.$route.name != "Accounts"
                ? this.$eventBus.$emit("refresh-job")
                : "";
              this.$emit("generateAdvance");
            },
            (error) => {
              this.processing = false;
              this.x.error = error.response.data.message;
            }
          );
        }
      } else {
        this.processing = false;
        return;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.layout__spacing .v-input__slot {
  min-height: auto !important;
}
.layout__spacing .v-text-field__slot input {
  margin-top: 0px !important;
}
</style>
<style scoped>
.request-advance-card {
  background: #ffffff !important;
  border: 0.0625rem solid #ebe9e2 !important;
  border-radius: 1rem !important;
  box-shadow: 0 1.25rem 2.5rem rgba(28, 43, 95, 0.14) !important;
  overflow: hidden;
  padding: 0 !important;
}

.request-advance-header {
  align-items: center;
  background:
    radial-gradient(circle at 100% 0%, rgba(245, 130, 32, 0.14), transparent 42%),
    linear-gradient(135deg, #fff7ed 0%, #ffffff 55%, #f4f7fb 100%);
  border-bottom: 0.0625rem solid #fed7aa;
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
  padding: 0.75rem 1rem;
}

.request-advance-header__brand {
  align-items: center;
  display: flex;
  gap: 0.7rem;
  min-width: 0;
}

.request-advance-header__badge {
  align-items: center;
  background: linear-gradient(160deg, #1c2b5f 0%, #2a3f7a 100%);
  border-radius: 0.7rem;
  box-shadow: 0 0.35rem 0.75rem rgba(28, 43, 95, 0.22);
  display: inline-flex;
  flex: 0 0 auto;
  height: 2.35rem;
  justify-content: center;
  position: relative;
  width: 2.35rem;
}

.request-advance-header__badge::after {
  background: #f58220;
  border-radius: 999px;
  bottom: 0.26rem;
  content: "";
  height: 0.18rem;
  left: 0.48rem;
  position: absolute;
  right: 0.48rem;
}

.request-advance-header__badge .v-icon {
  color: #ffffff !important;
  font-size: 1.05rem !important;
  margin-top: -0.1rem;
}

.request-advance-title-text {
  color: #1c2b5f;
  font-size: 1rem;
  font-weight: 800;
  letter-spacing: -0.01em;
  line-height: 1.2;
  margin: 0;
}

.request-advance-close {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  color: #5b6475 !important;
}

.request-advance-close ::v-deep .v-icon {
  color: #5b6475 !important;
}

.request-advance-body {
  background: #ffffff;
  display: block;
  max-height: min(78vh, 40rem);
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0;
  scrollbar-color: #c9c5bd transparent;
  scrollbar-width: thin;
}

.request-advance-body::-webkit-scrollbar {
  width: 0.3125rem;
}

.request-advance-body::-webkit-scrollbar-thumb {
  background: #c9c5bd;
  border-radius: 999px;
}

.request-advance-summary {
  align-items: center;
  background: #fffaf4;
  border: 0.0625rem solid #fed7aa;
  border-radius: 0.65rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem 0.65rem;
  margin: 0.75rem 1rem 0;
  padding: 0.55rem 0.8rem !important;
}

.request-advance-summary strong {
  color: #1c2b5f;
  font-size: 0.875rem;
  font-weight: 800;
}

.request-advance-grid,
.request-advance-payment-grid {
  display: grid;
  gap: 0.65rem 0.85rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  padding: 0.75rem 1rem 0 !important;
}

.request-advance-field {
  min-width: 0;
}

.request-advance-field--full {
  grid-column: 1 / -1;
}

.request-advance-label {
  color: #8a857c;
  display: block;
  font-size: 0.6875rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  line-height: 1.3;
  margin-bottom: 0.3rem;
  text-transform: uppercase;
}

.request-advance-section-heading {
  padding: 0.65rem 1rem 0 !important;
}

.request-advance-section-heading .heading__span {
  color: #c35f02 !important;
  font-size: 0.8125rem !important;
  font-weight: 800;
  letter-spacing: 0.04em;
  line-height: 1.2 !important;
  text-transform: uppercase;
}

.request-advance-card ::v-deep .request-advance-input {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.request-advance-card ::v-deep .v-input__slot {
  background: #ffffff !important;
  border: 0.0625rem solid #ebe9e2 !important;
  border-radius: 0.5rem !important;
  box-shadow: none !important;
  min-height: 2.5rem !important;
}

.request-advance-card ::v-deep .v-text-field__details,
.request-advance-card ::v-deep .v-messages {
  min-height: 0 !important;
}

.request-advance-card ::v-deep textarea,
.request-advance-card ::v-deep input {
  color: #3a382f !important;
  font-size: 0.8125rem !important;
}

.request-advance-radio ::v-deep .v-input--radio-group__input {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1.25rem;
}

.request-advance-actions {
  background: #fffaf4 !important;
  border-top: 0.0625rem solid #fed7aa;
  margin-top: 0.75rem;
  padding: 0.7rem 1rem !important;
  position: sticky;
  bottom: 0;
}

.request-advance-cancel-btn,
.request-advance-submit-btn {
  border-radius: 0.5rem !important;
  box-shadow: none !important;
  font-size: 0.75rem !important;
  font-weight: 800 !important;
  height: 2.25rem !important;
  letter-spacing: 0 !important;
  min-width: 5.25rem !important;
  text-transform: none !important;
}

.request-advance-cancel-btn {
  background: transparent !important;
  border: 0.0625rem solid #ebe9e2 !important;
  color: #3a382f !important;
}

.request-advance-submit-btn {
  background: #ea7a1c !important;
  border: 0.0625rem solid #ea7a1c !important;
  color: #ffffff !important;
}

.request-advance-submit-btn ::v-deep .v-btn__content {
  color: #ffffff !important;
}

.request-advance-ok-btn {
  min-width: 66px !important;
}

.tra-ass-btn {
  text-decoration: none;
  margin: 7px !important;
  color: #ffffff !important;
  background-color: #ea7a1c !important;
  border-radius: 8px;
  border: 1px solid #ea7a1c;
  padding: 6px 6px;
}

.request-advance-trigger-btn {
  background: #ea7a1c !important;
  border: 1px solid #ea7a1c !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(245, 130, 32, 0.25) !important;
  color: #ffffff !important;
  font-size: 12px !important;
  font-weight: 800 !important;
  height: 36px !important;
  letter-spacing: 0 !important;
  opacity: 1 !important;
  text-transform: none !important;
}

.request-advance-trigger-btn ::v-deep .v-btn__content {
  color: #ffffff !important;
  opacity: 1 !important;
}

.request-advance-trigger-btn.v-btn--disabled,
.request-advance-trigger-btn[disabled] {
  background: #f3ece4 !important;
  border: 1px solid #e2d5c6 !important;
  box-shadow: none !important;
  color: #8a6a4a !important;
  opacity: 1 !important;
}

.request-advance-trigger-btn.v-btn--disabled ::v-deep .v-btn__content,
.request-advance-trigger-btn[disabled] ::v-deep .v-btn__content {
  color: #8a6a4a !important;
  opacity: 1 !important;
}

.heading__span {
  font-size: 20px !important;
  line-height: 32px !important;
  font-weight: bold;
}

.dashboard-style {
  color: #8a857c;
  font-size: 0.8125rem;
  font-weight: 700;
}

.messagebtn {
  margin: 0 auto;
}

@media (max-width: 40rem) {
  .request-advance-grid,
  .request-advance-payment-grid {
    grid-template-columns: 1fr;
  }
}
</style>

<style>
.application .v-dialog.request-advance-dialog {
  border-radius: 1rem !important;
  height: auto !important;
  inline-size: min(52rem, calc(100vw - 2rem)) !important;
  margin: 1rem auto !important;
  max-height: calc(100vh - 2rem) !important;
  max-inline-size: min(52rem, calc(100vw - 2rem)) !important;
  max-width: min(52rem, calc(100vw - 2rem)) !important;
  min-inline-size: min(36rem, calc(100vw - 2rem)) !important;
  min-width: min(36rem, calc(100vw - 2rem)) !important;
  overflow: hidden !important;
  width: min(52rem, calc(100vw - 2rem)) !important;
}

.application .v-dialog.request-advance-dialog .request-advance-card {
  max-height: calc(100vh - 2rem);
  width: 100%;
}

/* Only this dialog's Submit — do not affect other dialogs */
.application
  .v-dialog.request-advance-dialog
  .request-advance-actions
  .request-advance-submit-btn.v-btn,
.application
  .v-dialog.request-advance-dialog
  .request-advance-actions
  .request-advance-submit-btn.v-btn.v-btn--flat,
.application
  .v-dialog.request-advance-dialog
  .request-advance-actions
  .request-advance-submit-btn.v-btn.orange,
.application
  .v-dialog.request-advance-dialog
  .request-advance-actions
  .request-advance-submit-btn.v-btn.orange--text {
  background: #ea7a1c !important;
  border: 0.0625rem solid #ea7a1c !important;
  box-shadow: 0 0.125rem 0.5rem rgba(234, 122, 28, 0.25) !important;
  color: #ffffff !important;
  opacity: 1 !important;
}

.application
  .v-dialog.request-advance-dialog
  .request-advance-actions
  .request-advance-submit-btn.v-btn
  .v-btn__content {
  color: #ffffff !important;
  opacity: 1 !important;
}

.application
  .v-dialog.request-advance-dialog
  .request-advance-actions
  .request-advance-cancel-btn.v-btn {
  background: #ffffff !important;
  border: 0.0625rem solid #ebe9e2 !important;
  color: #3a382f !important;
}

.application
  .v-dialog.request-advance-dialog
  .request-advance-actions
  .request-advance-cancel-btn.v-btn
  .v-btn__content {
  color: #3a382f !important;
}
</style>
